@if (quote.issueType !== undefined) {
  <td-wb-list listSize="compact"
              [embedded]="true"
              itemDivider="bottom"
              class="td-wb-quote-more-details"
              aria-labelledby="td-wb-aria-security-info-title">
    <ng-container *ngTemplateOutlet="currentTemplate" />
  </td-wb-list>
}

<ng-template #stock>
  @if (userHasDripPermission()) {
    <td-wb-list-item class="td-wb-quote-more-details__row">
      <td-wb-list-item-label translate="tdWb.markets.quote.stock.DIVIDEND_STATUS" />
      <td-wb-list-item-value [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }" />
    </td-wb-list-item>
    <td-wb-list-item class="td-wb-quote-more-details__row">
      <td-wb-list-item-label [innerText]="getDividendFrequencyHeader()" />
      <td-wb-list-item-value>
        @if ((quote.dividend.amountNext || quote.dividend.amountLast)) {
          @if (!quote.dividend.amountNext) {
            <span
              [innerText]="quote.dividend.amountLast | tdWbCurrency: { emptyPlaceholder: placeholder }">
          </span>
          }
          @if (quote.dividend.amountNext) {
            <span
              [innerText]="quote.dividend.amountNext | tdWbCurrency: { emptyPlaceholder: placeholder }">
          </span>
          }/<span [innerText]="quote.dividend.yield | tdWbPercent: { emptyPlaceholder: placeholder }">
        </span>
        } @else {
          <span [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }"></span>
        }
      </td-wb-list-item-value>
    </td-wb-list-item>
    <td-wb-list-item class="td-wb-quote-more-details__row">
      <td-wb-list-item-label translate="tdWb.markets.quote.stock.EX_DIVIDEND_DATE" />
      @if (quote.dividend.exDate) {
        <td-wb-list-item-value [innerText]="quote.dividend.exDate | tdWbDate" />
      } @else {
        <span [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }"></span>
      }
    </td-wb-list-item>
    <td-wb-list-item class="td-wb-quote-more-details__row">
      <td-wb-list-item-label class="td-wb-quote-stock-dividend-payDate-label"
                             translate="tdWb.markets.quote.stock.DIVIDEND_PAY_DATE" />
      @if (quote.dividend.dividendDate) {
        <td-wb-list-item-value [innerText]="quote.dividend.dividendDate | tdWbDate" />
      } @else {
        <span [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }"></span>
      }
    </td-wb-list-item>
    <td-wb-list-item class="td-wb-quote-more-details__row">
      <td-wb-list-item-label translate="tdWb.markets.quote.stock.DIVIDEND_TYPE" />
      <td-wb-list-item-value [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }" />
    </td-wb-list-item>
  } @else {
    <td-wb-list-item class="td-wb-quote-more-details__row">
      <td-wb-list-item-label translate="tdWb.markets.quote.stock.EX_DIVIDEND_DATE" />
      @if (quote.dividend.exDate) {
        <td-wb-list-item-value [innerText]="quote.dividend.exDate | tdWbDate" />
      } @else {
        <span [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }"></span>
      }
    </td-wb-list-item>
    <td-wb-list-item class="td-wb-quote-more-details__row">
      <td-wb-list-item-label class="td-wb-quote-stock-dividend-payDate-label"
                             translate="tdWb.markets.quote.stock.DIVIDEND_PAY_DATE" />
      @if (quote.dividend.dividendDate) {
        <td-wb-list-item-value [innerText]="quote.dividend.dividendDate | tdWbDate" />
      } @else {
        <span [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }"></span>
      }
    </td-wb-list-item>
    <td-wb-list-item class="td-wb-quote-more-details__row">
      <td-wb-list-item-label [innerText]="getDividendFrequencyHeader()" />
      <td-wb-list-item-value>
        @if ((quote.dividend.amountNext || quote.dividend.amountLast)) {
          @if (!quote.dividend.amountNext) {
            <span
              [innerText]="quote.dividend.amountLast | tdWbCurrency: { emptyPlaceholder: placeholder }">
          </span>
          }
          @if (quote.dividend.amountNext) {
            <span
              [innerText]="quote.dividend.amountNext | tdWbCurrency: { emptyPlaceholder: placeholder }">
          </span>
          }/<span [innerText]="quote.dividend.yield | tdWbPercent: { emptyPlaceholder: placeholder }">
        </span>
        } @else {
          <span [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }"></span>
        }
      </td-wb-list-item-value>
    </td-wb-list-item>
  }
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.stock.MARKET_CAP" />
    <td-wb-list-item-value [innerText]="quote.marketCap | tdWbCurrency: { emptyPlaceholder: placeholder, shorten: true }" />
  </td-wb-list-item>
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.stock.PE_RATIO" />
    <td-wb-list-item-value [innerText]="quote.peRatio | tdWbNumber: { emptyPlaceholder: placeholder }" />
  </td-wb-list-item>
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.stock.ESTIMATED_EARNINGS" />
    <td-wb-list-item-value [innerText]="quote.estimatedEarnings | tdWbCurrency: { emptyPlaceholder: placeholder }" />
  </td-wb-list-item>
</ng-template>

<ng-template #etf>
  @if (userHasDripPermission()) {
    <td-wb-list-item class="td-wb-quote-more-details__row">
      <td-wb-list-item-label translate="tdWb.markets.quote.stock.DIVIDEND_STATUS" />
      <td-wb-list-item-value [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }" />
    </td-wb-list-item>
    <td-wb-list-item class="td-wb-quote-more-details__row">
      <td-wb-list-item-label translate="tdWb.markets.quote.stock.EX_DIVIDEND_DATE" />
      @if (quote.dividend.exDate) {
        <td-wb-list-item-value [innerText]="quote.dividend.exDate | tdWbDate" />
      } @else {
        <span [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }"></span>
      }
    </td-wb-list-item>
    <td-wb-list-item class="td-wb-quote-more-details__row">
      <td-wb-list-item-label translate="tdWb.markets.quote.etf.DIVIDEND_PAYMENT_DATE" />
      <td-wb-list-item-value [innerText]="quote.dividend.dividendDate | tdWbDate: { emptyPlaceholder: placeholder }" />
    </td-wb-list-item>
    <td-wb-list-item class="td-wb-quote-more-details__row">
      <td-wb-list-item-label [innerText]="getDividendFrequencyHeader()" />
      <td-wb-list-item-value>
        @if ((quote.dividend.amountNext || quote.dividend.amountLast)) {
          <span>
          @if (!quote.dividend.amountNext) {
            <span
              [innerText]="quote.dividend.amountLast | tdWbCurrency: { emptyPlaceholder: placeholder }"></span>
          }
            @if (quote.dividend.amountNext) {
              <span
                [innerText]="quote.dividend.amountNext | tdWbCurrency: { emptyPlaceholder: placeholder }"></span>
            }/
            <span [innerText]="quote.dividend.yield | tdWbPercent: { emptyPlaceholder: placeholder }"></span>
          </span>
        } @else {
          <span [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }"></span>
        }
      </td-wb-list-item-value>
    </td-wb-list-item>
    <td-wb-list-item class="td-wb-quote-more-details__row">
      <td-wb-list-item-label translate="tdWb.markets.quote.stock.DIVIDEND_TYPE" />
      <td-wb-list-item-value [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }" />
    </td-wb-list-item>
    <td-wb-list-item class="td-wb-quote-more-details__row">
      <td-wb-list-item-label translate="tdWb.markets.quote.FUND_INCEPTION" />
      <td-wb-list-item-value [innerText]="quote.inceptionDate | tdWbDate: { emptyPlaceholder: placeholder }" />
    </td-wb-list-item>
    <td-wb-list-item class="td-wb-quote-more-details__row td-wb-quote-more-details__row--group">
      <td-wb-list-item-label translate="tdWb.markets.quote.MANAGEMENT_EXPENSE_RATIO" />
    </td-wb-list-item>
    <td-wb-list-item
      class="td-wb-quote-more-details__row td-wb-quote-more-details__row--mer td-wb-quote-more-details__row--group">
      <td-wb-list-item-label translate="tdWb.markets.quote.GROSS" />
      <td-wb-list-item-value [innerText]="quote.grossManagementExpenseRatio | tdWbPercent: { emptyPlaceholder: placeholder }" />
    </td-wb-list-item>
    <td-wb-list-item class="td-wb-quote-more-details__row td-wb-quote-more-details__row--mer">
      <td-wb-list-item-label translate="tdWb.markets.quote.NET" />
      <td-wb-list-item-value [innerText]="quote.netManagementExpenseRatio | tdWbPercent: { emptyPlaceholder: placeholder }" />
    </td-wb-list-item>
  } @else {
    <td-wb-list-item class="td-wb-quote-more-details__row">
      <td-wb-list-item-label translate="tdWb.markets.quote.FUND_INCEPTION" />
      <td-wb-list-item-value [innerText]="quote.inceptionDate | tdWbDate: { emptyPlaceholder: placeholder }" />
    </td-wb-list-item>
    <td-wb-list-item class="td-wb-quote-more-details__row td-wb-quote-more-details__row--group">
      <td-wb-list-item-label translate="tdWb.markets.quote.MANAGEMENT_EXPENSE_RATIO" />
    </td-wb-list-item>
    <td-wb-list-item
      class="td-wb-quote-more-details__row td-wb-quote-more-details__row--mer td-wb-quote-more-details__row--group">
      <td-wb-list-item-label translate="tdWb.markets.quote.GROSS" />
      <td-wb-list-item-value [innerText]="quote.grossManagementExpenseRatio | tdWbPercent: { emptyPlaceholder: placeholder }" />
    </td-wb-list-item>
    <td-wb-list-item class="td-wb-quote-more-details__row td-wb-quote-more-details__row--mer">
      <td-wb-list-item-label translate="tdWb.markets.quote.NET" />
      <td-wb-list-item-value [innerText]="quote.netManagementExpenseRatio | tdWbPercent: { emptyPlaceholder: placeholder }" />
    </td-wb-list-item>
    <td-wb-list-item class="td-wb-quote-more-details__row">
      <td-wb-list-item-label translate="tdWb.markets.quote.etf.DIVIDEND_PAYMENT_DATE" />
      <td-wb-list-item-value [innerText]="quote.dividend.dividendDate | tdWbDate: { emptyPlaceholder: placeholder }" />
    </td-wb-list-item>
    <td-wb-list-item class="td-wb-quote-more-details__row">
      <td-wb-list-item-label [innerText]="getDividendFrequencyHeader()" />
      <td-wb-list-item-value>
        @if ((quote.dividend.amountNext || quote.dividend.amountLast)) {
          <span>
          @if (!quote.dividend.amountNext) {
            <span
              [innerText]="quote.dividend.amountLast | tdWbCurrency: { emptyPlaceholder: placeholder }"></span>
          }
            @if (quote.dividend.amountNext) {
              <span
                [innerText]="quote.dividend.amountNext | tdWbCurrency: { emptyPlaceholder: placeholder }"></span>
            }/
            <span [innerText]="quote.dividend.yield | tdWbPercent: { emptyPlaceholder: placeholder }"></span>
          </span>
        } @else {
          <span [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }"></span>
        }
      </td-wb-list-item-value>
    </td-wb-list-item>
  }

</ng-template>

<ng-template #index>
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.HIGH" />
    <td-wb-list-item-value [innerText]="quote.priceHigh | tdWbNumber: { format: 'n2', emptyPlaceholder: placeholder }" />
  </td-wb-list-item>
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.LOW" />
    <td-wb-list-item-value [innerText]="quote.priceLow | tdWbNumber: { format: 'n2', emptyPlaceholder: placeholder }" />
  </td-wb-list-item>
</ng-template>

<ng-template #mf>
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.mf.DISTRIBUTION_YIELD" />
    <td-wb-list-item-value [innerText]="quote.distributionYield | tdWbNumber: { format: 'n2', emptyPlaceholder: placeholder }" />
  </td-wb-list-item>
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.mf.LOAD_TYPE" />
    <td-wb-list-item-value>
      @if (quote.loadType) {
        <span
          [innerText]="getLoadType()"></span>
      } @else {
        <span [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }"></span>
      }
    </td-wb-list-item-value>
  </td-wb-list-item>
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.MANAGEMENT_EXPENSE_RATIO" />
    <td-wb-list-item-value [innerText]="quote.grossManagementExpenseRatio | tdWbPercent: { emptyPlaceholder: placeholder }" />
  </td-wb-list-item>
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.mf.AUM" />
    <td-wb-list-item-value [innerText]="quote.assetsUnderManagement | tdWbNumber: { emptyPlaceholder: placeholder, shorten: true }" />
  </td-wb-list-item>
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.mf.YTD" />
    <td-wb-list-item-value [innerText]="quote.ytdPct | tdWbPercent: { emptyPlaceholder: placeholder }" />
  </td-wb-list-item>
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.mf.RRSP_ELIGIBILITY" />
    <td-wb-list-item-value>
      @if (quote.isRRSPEligible === true) {
        <span translate="tdWb.markets.quote.YES"></span>
      }
      @if (quote.isRRSPEligible === false) {
        <span translate="tdWb.markets.quote.NO"></span>
      }
    </td-wb-list-item-value>
  </td-wb-list-item>
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.FUND_INCEPTION" />
    <td-wb-list-item-value [innerText]="quote.inceptionDate | tdWbDate: {emptyPlaceholder: placeholder }" />
  </td-wb-list-item>
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.FUND_CATEGORY" />
    <td-wb-list-item-value [innerText]="quote.fundCategory | tdWbPlaceholder : { defaultValue:  '-'}" />
  </td-wb-list-item>
</ng-template>

<ng-template #option>
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.option.IMPLIED_VOLATILITY" />
    <td-wb-list-item-value [innerText]="quote.impliedVolatility | tdWbPercent: { format: 'n4', emptyPlaceholder: placeholder }" />
  </td-wb-list-item>
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.option.DELTA" />
    <td-wb-list-item-value [innerText]="quote.delta  | tdWbNumber: { format: 'n3', emptyPlaceholder: placeholder }" />
  </td-wb-list-item>
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.option.GAMMA" />
    <td-wb-list-item-value [innerText]="quote.gamma | tdWbNumber: { format: 'n3', emptyPlaceholder: placeholder }" />
  </td-wb-list-item>
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.option.THETA" />
    <td-wb-list-item-value [innerText]="quote.theta  | tdWbNumber: { format: 'n3', emptyPlaceholder: placeholder }" />
  </td-wb-list-item>
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.option.VEGA" />
    <td-wb-list-item-value [innerText]="quote.vega | tdWbNumber: { format: 'n3', emptyPlaceholder: placeholder }" />
  </td-wb-list-item>
  <td-wb-list-item class="td-wb-quote-more-details__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.option.RHO" />
    <td-wb-list-item-value [innerText]="quote.rho | tdWbNumber: { format: 'n3', emptyPlaceholder: placeholder }" />
  </td-wb-list-item>
</ng-template>

